import { createContext, useContext, useState, type ReactNode } from 'react';

interface HeaderActionsContextType {
  headerActions: ReactNode;
  setHeaderActions: (actions: ReactNode) => void;
  showBackButton: boolean;
  setShowBackButton: (show: boolean) => void;
  backButtonPath?: string;
  setBackButtonPath: (path?: string) => void;
}

const HeaderActionsContext = createContext<HeaderActionsContextType | undefined>(undefined);

export function HeaderActionsProvider({ children }: { children: ReactNode }) {
  const [headerActions, setHeaderActions] = useState<ReactNode>(null);
  const [showBackButton, setShowBackButton] = useState(false);
  const [backButtonPath, setBackButtonPath] = useState<string | undefined>(undefined);

  return (
    <HeaderActionsContext.Provider value={{ 
      headerActions, 
      setHeaderActions,
      showBackButton,
      setShowBackButton,
      backButtonPath,
      setBackButtonPath
    }}>
      {children}
    </HeaderActionsContext.Provider>
  );
}

export function useHeaderActions() {
  const context = useContext(HeaderActionsContext);
  if (context === undefined) {
    throw new Error('useHeaderActions must be used within a HeaderActionsProvider');
  }
  return context;
}
